import React, { useMemo } from "react";
import { useField } from "formik";

import ICONS from "../../constants/icons";

import { IconButton } from "../buttons";
import { Aria } from "../../types/aria";

const InputField = <T extends object>({
  handleClick,
  buttonType,
  label,
  dark = false,
  error,
  required,
  iconColor,
  subscribe = false,
  aria,
  ...props
}: {
  name: string;
  label?: string;
  placeholder: string;
  handleClick?: (formData?: T) => void;
  buttonType?: "button" | "reset" | "submit";
  dark?: boolean;
  error?: string;
  required?: boolean;
  iconColor?: string;
  subscribe?: boolean;
  aria?: Aria
}) => {
  const [field, meta, helpers] = useField(props);

  const { value } = field;

  const { setValue } = helpers;

  const hasError = meta.touched && meta.error;

  const errorMessageClass = useMemo(() => {
    if (dark || subscribe) {
      return "a-errorMessage";
    } else {
      return "a-whiteErrorMessage";
    }
  }, [dark, subscribe]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setValue(value);
  };

  return (
    <div className="m-inputGroup column fullWidth">
      {label && (
        <label htmlFor={label}>
          {label} {required && <span className="-requiredStar">*</span>}
        </label>
      )}
      <input
        {...props}
        className={`a-input ${hasError ? "-error" : ""} ${
          dark ? "-darkInput" : ""
        } ${subscribe ? "-subscribe" : ""}`}
        value={value}
        onChange={handleChange}
        id={label}
      />
      {!dark && (
        <IconButton
          handleClick={handleClick}
          name={ICONS.SECOND_RIGHT_ARROW}
          type={buttonType}
          color={iconColor}
          aria={aria}
        />
      )}
      {hasError && <span className={errorMessageClass}> {hasError} </span>}
    </div>
  );
};

export default InputField;
